export default __webpack_public_path__ + "5786464352b67ec4089b3d0e2e48d818.png";